<template>
  <div v-if="visible && versionNumber" class="win-version">
    <vs-button @click="download" class="win-version-button">دانلود نسخه ویندوز
      پنل مدیریت</vs-button>
    <vs-button @click="close" icon-pack="feather" icon="icon-x" />
  </div>
</template>

<script>
import { isMobileView } from './helpers/Functions';
import providerApiService from './services/api/ProviderApiService';

export default {
  data() {
    return {
      visible: true,
      versionNumber: null,
    };
  },
  mounted() {
    const isMobile = isMobileView();
    this.visible = !isMobile;

    if (this.visible) {
      this.getLatestRelease();
    }
  },
  methods: {
    getLatestRelease() {
      providerApiService.latestRelease().then(result => {
        if (result.data) {
          this.versionNumber = result.data.version;
        }
      });
    },
    download() {
      window.open(
        `https://www.topmenumarket.com/storage/download/desktop/top-menu-panel-${this.versionNumber}.exe`
      );
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.win-version {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100000;
  background-color: rgba(var(--vs-primary), 1) !important;
  width: 240px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.win-version-button {
  padding: 13px 5px !important;
}
</style>
